import React from 'react';
import { REASSURANCE } from '../data/site';
import Reveal from './Reveal';

export default function BandeauReassurance() {
  return (
    <section className="bg-white border-b border-nuit/10">
      <div className="conteneur py-9">
        <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {REASSURANCE.map((r, i) => (
            <Reveal key={r.titre} delai={i * 0.06}>
              <li className="border-t-4 border-jaune pt-3.5">
                <p className="font-cond uppercase font-bold tracking-[0.04em] text-[16px] text-nuit leading-tight">
                  {r.titre}
                </p>
                <p className="mt-1.5 text-[14.5px] text-beton leading-snug">{r.detail}</p>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
